const url = window.location.hostname === "localhost" ? "odacafe.com" : window.location.hostname
const domainName = 'ODACMS';

export const ServerConfiguration = {
  APIServerUrl: `https://${url}/ODACMSApi/api/${domainName}/`,
  devServerUrl: `https://${url}/ODACMSApiDev/api/${domainName}/`,
  uploadUrl: "https://odacafe.com/ODAImage/upload.php",
  uploadUrlNoID: "https://cms.emporia.my/eCommerceCMSImage/uploadWithoutID.php"
}
